import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HierarchyLevelType } from 'common/interfaces/hierarchy-entities';

type TItemsOpenedState = {
  [id: string]: true,
};
type TActiveItem = {
  id: string;
  entityType: HierarchyLevelType;
} | null;

const initialState = {
  openedItems: {} as TItemsOpenedState,
  selectedArchiveId: null as string | null,
  activeItem: null as TActiveItem,
  isAfterUnpackedActiveArchive: false,
};

const hierarchyTree = createSlice({
  name: 'hierarchy-tree',
  initialState,
  reducers: {
    addToOpenedItems: (state, action: PayloadAction<string>) => {
      state.openedItems[action.payload] = true;
    },
    removeFromOpenedItems: (state, action: PayloadAction<string>) => {
      delete state.openedItems[action.payload];
    },
    resetOpenedItems: (state) => {
      state.openedItems = {};
    },
    setSelectedArchiveId: (state, action: PayloadAction<string | null>) => {
      state.selectedArchiveId = action.payload;
      state.openedItems = {};
      if (!action.payload) {
        state.activeItem = null;
      } else {
        state.activeItem = {
          id: action.payload,
          entityType: HierarchyLevelType.Archive,
        };
      }
    },
    setActiveItem: (state, action: PayloadAction<TActiveItem>) => {
      state.activeItem = action.payload;
    },
    setAfterUnpackedActiveArchiveState: (state, action: PayloadAction<boolean>) => {
      state.isAfterUnpackedActiveArchive = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) => /.+\/itemDeleteRecieved/.test(action.type), // hierarchy item deleted
        (state, action: PayloadAction<any>) => {
          if (state.selectedArchiveId === action.payload) {
            state.selectedArchiveId = null;
            state.openedItems = {};
            state.activeItem = null;
          } else {
            delete state.openedItems[action.payload];
            if (state.activeItem?.id === action.payload) {
              state.activeItem = null;
            }
          }
          return state;
        },
      );
  },
});

export const {
  addToOpenedItems,
  removeFromOpenedItems,
  resetOpenedItems,
  setSelectedArchiveId,
  setActiveItem,
  setAfterUnpackedActiveArchiveState,
} = hierarchyTree.actions;

export default hierarchyTree.reducer;
